<div class="footer-quicklinks bg-secondary w-100 text-center d-flex font-size-14">
  <a class="text-white my-auto" [routerLink]="['/terms']">{{ 'footer.terms' | translate }}</a>
  <a class="text-white my-auto" [routerLink]="['/faq']">{{ 'footer.faqs' | translate }}</a>
</div>
